import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Box, useMediaQuery } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import { ZoomableImage } from "../image/ZoomableImage";
import Dots from "../startWorkout/Dots";

const useStyles = makeStyles((theme) => ({
  dots: {
    marginTop: 10,
  },

  imageContainer: {
    display: "flex",
    flexFlow: "column nowrap",
    overflowX: "auto",
    width: "100%",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up("sm")]: {
      flexFlow: "row nowrap",
    },
  },

  image: {
    width: "100%",
    height: theme.spacing(35),
    border: "1px solid",
    borderColor: theme.palette.border.primary,
    borderRadius: theme.spacing(1),
    objectFit: "cover",
    margin: theme.spacing(0, 2, 2, 0),

    "&:not(:last-child)": {
      [theme.breakpoints.up("sm")]: {
        marginBottom: 0,
        marginRight: theme.spacing(1),
      },
    },
    [theme.breakpoints.up("sm")]: {
      maxWidth: "30%",
      margin: 0,
    },
  },
}));

interface WorkoutMedia {
  url: string;
  fileName?: string;
}

interface ActivityWorkoutMediaProps {
  media?: WorkoutMedia[];
}

export const ActivityWorkoutMedia: React.FC<ActivityWorkoutMediaProps> = ({
  media,
}) => {
  const isSmDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [selectedPhoto, setSelectedPhoto] = React.useState(0);
  const s = useStyles();

  const handlePageChange = (page: number) => {
    setSelectedPhoto(page > 0 ? page % media.length : media.length - 1);
  };

  return (
    <Box className={s.imageContainer}>
      {isSmDown ? (
        <>
          <SwipeableViews
            index={selectedPhoto}
            onChangeIndex={handlePageChange}
            slideStyle={{ overflow: "hidden", padding: 10 }}
          >
            {media.map((item, index) => (
              <ZoomableImage
                key={index}
                className={s.image}
                src={item.url}
                alt={item.fileName}
              />
            ))}
          </SwipeableViews>

          <Dots
            className={s.dots}
            activeDot={selectedPhoto}
            dots={media.length}
          />
        </>
      ) : (
        media.map((item, index) => (
          <ZoomableImage
            key={index}
            className={s.image}
            src={item.url}
            alt={item.fileName}
          />
        ))
      )}
    </Box>
  );
};
